import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GeoMarkWebsite from './components/GeoMarkWebsite';
import AdminPanel from './components/AdminPanel';
import ServiceHazelnutProcessing from './components/ServiceHazelnutProcessing';
import ServiceMetalFabrication from './components/ServiceMetalFabrication';
import ServiceCustomManufacturing from './components/ServiceCustomManufacturing';

function App() {
  const [language, setLanguage] = useState('ka');

  return (
    <Router>
      <Routes>
        <Route path="/" element={<GeoMarkWebsite language={language} setLanguage={setLanguage} />} />
        <Route path="/minaular" element={<AdminPanel />} />
        <Route path="/service/hazelnut-processing" element={<ServiceHazelnutProcessing language={language} />} />
        <Route path="/service/metal-fabrication" element={<ServiceMetalFabrication language={language} />} />
        <Route path="/service/custom-manufacturing" element={<ServiceCustomManufacturing language={language} />} />
      </Routes>
    </Router>
  );
}

export default App;
